var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ width: _vm.width, height: _vm.height }),attrs:{"id":"mapWB"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }